/**
 * Web URLs for the sounds we ship ourselves (the ones uisfx has no cue for).
 * Vite turns each import into a hashed, immutably-cached asset URL; mobile's
 * counterpart is `flashka-app/src/lib/sound/local-assets.ts` with Metro
 * `require()`s of the SAME files, so both platforms play identical bytes.
 *
 * The files are rendered by `shared/scripts/generate-card-flip.mjs`.
 */

import type { LocalSoundAsset } from '@flashka/shared/sound';
import cardFlipA from '@flashka/shared/sound/assets/card-flip-a.wav';

export const LOCAL_ASSET_URLS: Record<LocalSoundAsset, string> = {
  'card-flip-a': cardFlipA,
};
